import React from 'react';
import { Slider as MuiSlider, styled } from '@mui/material';
import { Colors } from 'library';

interface SliderProps {
    value: number;
    onChange: (value: number) => void;
    min: number;
    max: number;
    step?: number;
}

export function Slider({ value, onChange, min, max, step }: SliderProps) {
    return (
        <StyledSlider
            value={value}
            onChange={(_, val) => onChange(val as number)}
            min={min}
            max={max}
            step={step}
        />
    );
}

const StyledSlider = styled(MuiSlider)({
    color: Colors.darkNavy,
    '& .MuiSlider-thumb': {
        width: 20,
        height: 20,
        backgroundColor: Colors.white,
        border: `2px solid ${Colors.darkNavy}`,
        '&:hover, &.Mui-focusVisible': {
            boxShadow: `0 0 0 6px ${Colors.darkNavy}20`,
        },
    },
    '& .MuiSlider-track': {
        height: 6,
    },
    '& .MuiSlider-rail': {
        height: 6,
        color: Colors.turquoise,
        opacity: 1,
    },
});
